export var ExclusionStatusType;
(function (ExclusionStatusType) {
    ExclusionStatusType["ACTIVE"] = "ACTIVE";
    ExclusionStatusType["ON_BREAK"] = "ON_BREAK";
    ExclusionStatusType["EXCLUDED"] = "EXCLUDED";
})(ExclusionStatusType || (ExclusionStatusType = {}));
//# sourceMappingURL=exclusion-status-type.js.map